import React, { useState } from "react";
import LoadModelButton from "../components/button/LoadModelButton.js";
import LoadModelButtonWrapper from "../components/button/LoadModelButtonWrapper.js";
import Button from "../components/button/Button";
import ButtonText from "../components/button/ButtonText";
import ButtonsGroup from "../components/button/ButtonsGroup";
import ButtonWrapper from "../components/button/ButtonWrapper";
import ButtonLayout from "../components/button/ButtonLayout";
import * as BabylonViewer from "@babylonjs/viewer";
import ARIcon from "../components/ARIcon.js";
import LoadModelSVG from "../components/button/LoadModelSVG.js";
import { Link } from "react-router-dom";
import { isDesktop, isIOS, isAndroid } from "react-device-detect";
import ARIconSVG from "../components/ARIconSVG.js";
import ChristmasText from "../components/ChristmasText.js";
import PoweredText from "../components/PoweredText.js";
import AlphaLogoSVG from "../components/AlphaLogoSVG.js";

const ButtonsGroupContainer = ({
  resource,
  modelLoaded,
  setModelLoaded,
  showModal,
  christmasTheme,
}) => {
  const [sceneViewerLink, changeSceneViewerLink] = useState("");
  let christmasText;
  let poweredText;

  const loadModel = (resource) => {
    BabylonViewer.viewerManager
      .getViewerPromiseById("babylon-viewer")
      .then(function (viewer) {
        viewer.loadModel({
          title: "AlphaAR Model",
          subtitle: "AlphaAR 3D",
          url: resource.androidModel.fileLocation,
        });
        setModelLoaded(true);
      });
  };

  const handleSceneViewerLink = (e) => {
    if (isIOS) {
      changeSceneViewerLink(resource?.iosModel?.fileLocation);
    }
    if (isAndroid) {
      let verticalPlacement = "false";
      if (
        resource.resourceId == "859e90a5-9a20-4485-b6f5-c52eca10ccd5" ||
        resource.resourceId == "dd87b82e-1ee6-4a24-bff4-11d04e184f88" ||
        resource.resourceId == "6fbe9c1c-110a-47d6-922e-eda830803cca"
      )
        verticalPlacement = "true";
      changeSceneViewerLink(`intent://arvr.google.com/scene-viewer/1.0?file=
                ${resource?.androidModel?.fileLocation}&mode=ar_preferred&enable_vertical_placement=${verticalPlacement}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`);
    }

    if (isDesktop) {
      e.preventDefault();
      showModal(true);
    }
  };

  if (christmasTheme) {
    christmasText = (
      <ChristmasText>
        When the festive season meets <br />
        tech, we're up to snow good!
        <p style={{ fontSize: "18px", fontWeight: "300" }}>
          Take a peak inside to see if we're on the naughty or nice list.
          <br />
          Happy holidays from the VivaTech Team!
        </p>
      </ChristmasText>
    );
    poweredText = (
      <PoweredText>
        <Link
          style={{ textDecoration: "none", color: "white" }}
          to={{ pathname: "https://alphaar.io" }}
          target="_blank"
        >
          Powered by
          <AlphaLogoSVG
            style={{ height: "16px", verticalAlign: "bottom", width: "86px" }}
            viewBox="0 0 157 33"
          >
            <path
              d="M5.44469 27.6897L6.9749 23.3481H17.3661L18.8963 27.6897H24.4833L14.9818 2.42345H9.50152L0 27.6897H5.44469ZM12.2061 8.82897L15.6935 18.6863H8.64745L12.1349 8.82897H12.2061Z"
              fill="white"
            />
            <path d="M31.764 27.6897V1H26.7108V27.6897H31.764Z" fill="white" />
            <path
              d="M41.4599 25.6968C42.4207 26.9779 44.3424 28.1167 46.9757 28.1167C52.3848 28.1167 55.552 23.7752 55.552 18.3661C55.552 12.957 52.3848 8.61545 46.9757 8.61545C44.3424 8.61545 42.2428 9.61186 41.0684 11.32V9.04248H36.4066V35.0916H41.4599V25.6968ZM41.3175 18.3661C41.3175 15.3412 43.0968 13.0637 45.9082 13.0637C48.7195 13.0637 50.4988 15.3412 50.4988 18.3661C50.4988 21.3909 48.7195 23.6684 45.9082 23.6684C43.0968 23.6684 41.3175 21.3909 41.3175 18.3661Z"
              fill="white"
            />
            <path
              d="M64.0488 1H58.9955V27.6897H64.0488V17.0494C64.0488 14.4872 65.4011 12.957 67.8565 12.957C70.0984 12.957 71.0237 14.4516 71.0237 16.6223V27.6897H76.0769V16.053C76.0769 11.6047 73.6926 8.61545 69.2088 8.61545C66.7889 8.61545 65.0096 9.46952 64.0488 10.7506V1Z"
              fill="white"
            />
            <path
              d="M93.8511 9.04248V11.32C92.6768 9.61186 90.5772 8.61545 87.9438 8.61545C82.5347 8.61545 79.3675 12.957 79.3675 18.3661C79.3675 23.7752 82.5347 28.1167 87.9438 28.1167C90.5772 28.1167 92.6768 27.1203 93.8511 25.4121V27.6897H98.5129V9.04248H93.8511ZM93.602 18.3661C93.602 21.3909 91.8227 23.6684 89.0114 23.6684C86.2001 23.6684 84.4208 21.3909 84.4208 18.3661C84.4208 15.3412 86.2001 13.0637 89.0114 13.0637C91.8227 13.0637 93.602 15.3412 93.602 18.3661Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M108.343 2.34315C106 4.68629 106 8.45753 106 16V19.5862C106 27.1287 106 30.8999 108.343 33.2431C110.686 35.5862 114.458 35.5862 122 35.5862H140.414C147.956 35.5862 151.728 35.5862 154.071 33.2431C156.414 30.8999 156.414 27.1287 156.414 19.5862V16C156.414 8.45753 156.414 4.68629 154.071 2.34315C151.728 0 147.956 0 140.414 0H122C114.458 0 110.686 0 108.343 2.34315ZM119.65 22.9498L118.63 25.8441H115L121.334 8.99997H124.988L131.322 25.8441H127.598L126.577 22.9498H119.65ZM125.462 19.8419L123.137 13.2703H123.09L120.765 19.8419H125.462ZM143.317 19.0827L146.994 25.8441H142.985L139.83 19.4623H136.508V25.8441H133.044V8.99997H140.684C144.361 8.99997 146.306 11.1826 146.306 14.2667C146.306 16.4968 145.286 18.2761 143.317 19.0827ZM140.684 16.2833C142.131 16.2833 142.843 15.5004 142.843 14.2667C142.843 13.0331 142.131 12.179 140.684 12.179H136.508V16.2833H140.684Z"
              fill="white"
            />
          </AlphaLogoSVG>
        </Link>
      </PoweredText>
    );
  }

  return (
    <ButtonsGroup
      isDesktop={isDesktop}
      christmasTheme={christmasTheme}
      theme={resource.theme}
    >
      {christmasText}

      <LoadModelButtonWrapper
        show={
          resource.theme != "vivaTheme" || modelLoaded
            ? false
            : christmasTheme
            ? false
            : true
        }
        theme={resource.theme}
      >
        <LoadModelButton
          onClick={() => loadModel(resource)}
          theme={resource.theme}
        >
          <ARIcon>
            <LoadModelSVG viewBox="0 0 512 512">
              <path
                d="M68.983,382.642l171.35,98.928a32.082,32.082,0,0,0,32,0l171.352-98.929a32.093,32.093,0,0,0,16-27.713V157.071a32.092,32.092,0,0,0-16-27.713L272.334,30.429a32.086,32.086,0,0,0-32,0L68.983,129.358a32.09,32.09,0,0,0-16,27.713V354.929A32.09,32.09,0,0,0,68.983,382.642ZM272.333,67.38l155.351,89.691V334.449L272.333,246.642ZM256.282,274.327l157.155,88.828-157.1,90.7L99.179,363.125ZM84.983,157.071,240.333,67.38v179.2L84.983,334.39Z"
                fill="#0A083A"
              />
            </LoadModelSVG>
          </ARIcon>
          View in 3D
        </LoadModelButton>
      </LoadModelButtonWrapper>

      <Button theme={resource.theme} christmasTheme={christmasTheme}>
        <ButtonWrapper>
          <a
            style={{ textDecoration: "none" }}
            rel="ar"
            onClick={handleSceneViewerLink}
            href={sceneViewerLink}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                display: "none"
              }}
            />
            <ButtonLayout christmasTheme={christmasTheme}>
              <ButtonText christmasTheme={christmasTheme}>
                <ARIcon>
                  <ARIconSVG viewBox="0 0 24 24">
                    <path
                      d="M7.05872 8.74023V15.4046L11.9999 17.7208L16.9411 15.4046V8.74023L11.9999 6.26964L7.05872 8.74023ZM11.294 8.20093V12.2816L8.47048 13.7816V9.6127L11.294 8.20093ZM9.34352 14.9164L11.9999 13.5052L14.6563 14.9164L11.9999 16.1616L9.34352 14.9164ZM15.5293 13.7816L12.7058 12.2816V8.20093L15.5293 9.6127V13.7816Z"
                      fill={christmasTheme ? "white" : "#0A083A"}
                    />
                    <path
                      d="M23.2941 9.17646V4.23528H20.4706V-1.52588e-05H3.5294V4.23528H0.705872V9.17646H2.11764V5.64704H3.5294V18.3529H2.11764V14.8235H0.705872V19.7647H3.5294V24H20.4706V19.7647H23.2941V14.8235H21.8823V18.3529H20.4706V5.64704H21.8823V9.17646H23.2941ZM19.0588 18.3529H17.647V19.7647H19.0588V22.5882H4.94117V19.7647H6.35293V18.3529H4.94117V5.64704H6.35293V4.23528H4.94117V1.41175H19.0588V4.23528H17.647V5.64704H19.0588V18.3529Z"
                      fill={christmasTheme ? "white" : "#0A083A"}
                    />
                    <path
                      d="M10.5883 19.7648H13.4118V21.1765H10.5883V19.7648Z"
                      fill={christmasTheme ? "white" : "#0A083A"}
                    />
                    <path
                      d="M11.2941 2.82349H12.7059V4.23525H11.2941V2.82349Z"
                      fill={christmasTheme ? "white" : "#0A083A"}
                    />
                  </ARIconSVG>
                </ARIcon>
                {resource.theme == "vivaTheme"
                  ? christmasTheme
                    ? "View in your space"
                    : "View in AR"
                  : "View in your space"}
              </ButtonText>
            </ButtonLayout>
          </a>
        </ButtonWrapper>
      </Button>
      {poweredText}
    </ButtonsGroup>
  );
};

export default ButtonsGroupContainer;
